import Cookies from 'js-cookie';

import modal from 'assets/components/modal/modal';
import { formValidation, klaviyo } from 'assets/utilities';

import './newsletterModal.scss';

const COOKIE_NAME = 'NEWSLETTER_MODAL_SEEN';
const COOKIE_EXPIRATION = 7;

window.settings = window.settings || {};
const copyHeading = window.settings.newsletter_modal_heading;
const copySuccess = window.settings.newsletter_modal_success;

const CLASSNAME_SUCCESS = 'newsletter-modal--success';
const SELECTOR_FORM = '.js-newsletterModal';

const CONTENT = {
  modifier: 'newsletter',
  title: copyHeading,
  content: `<form class="newsletter-modal ${SELECTOR_FORM.substr(1)}">
  <div>
    <input aria-label="Your e-mail address" placeholder="Enter your email" required type="email" name="EMAIL" />
  </div>
  <button type="submit">Subscribe</button>
  <p tabindex="-1" class="newsletter-modal__success js-newsletterModalSuccess">
    ${copySuccess}
  </p>
</form>`,
  id: 'newsletter',
};

const onNewsletterError = function onNewsletterModalNewsletterError(err) {
  const form = document.querySelector(SELECTOR_FORM);
  const message = err.message || '';
  const id = form.querySelector('input').getAttribute('id');

  const submit = form.querySelector('button');
  submit.disabled = false;

  submit.insertAdjacentHTML(
    'afterend',
    `<label aria-live="polite" class="form__error-msg" for="${id}">
      An error occurred${message ? ` - ${message}` : ''}
    </label>`,
  );
};

const onNewsletterResponse = function onNewsletterModalNewsletterResponse(response) {
  const form = document.querySelector(SELECTOR_FORM);
  const formSuccess = document.querySelector('.js-newsletterModalSuccess');
  const hasError = response.data
    && response.data.errors
    && response.data.errors.length;

  if (!form) {
    return;
  }

  if (hasError) {
    onNewsletterError({ message: response.data.errors.join(' ') });
  } else {
    form.classList.add(CLASSNAME_SUCCESS);
    formSuccess.focus();
  }
};

const submitForm = function submitSignupForm(form) {
  const email = form.elements.EMAIL.value || '';
  const source = form.elements.SOURCE ? form.elements.SOURCE.value : 'NewsletterModal';
  const submit = form.querySelector('button');

  const errorEl = form.querySelector('.form__error-msg');
  if (errorEl) {
    errorEl.parentNode.removeChild(errorEl);
  }

  submit.disabled = true;
  klaviyo.subscribe({
    email,
    source,
  })
    .then(onNewsletterResponse)
    .catch(onNewsletterError);
};

const onFormSubmit = function onSignupFormSubmit(ev) {
  const elForm = ev.currentTarget;
  const isValid = formValidation.validate(elForm);
  ev.preventDefault();

  if (isValid) {
    submitForm(elForm);
  }
};

const init = function initNewsletterModal() {
  if (klaviyo.getIsSubscribed() || Cookies.get(COOKIE_NAME)) {
    return;
  }

  if (!copyHeading || !copySuccess) {
    return;
  }

  modal.render(CONTENT);
  setTimeout(() => {
    modal.open(CONTENT.id);
    Cookies.set(COOKIE_NAME, COOKIE_EXPIRATION);
  }, 5000);

  const form = document.querySelector(SELECTOR_FORM);
  form.addEventListener('submit', onFormSubmit);
  form.setAttribute('novalidate', 'true');
  formValidation.bindChange(form);
};

export default {
  init,
};
